module.exports = __webpack_public_path__ + "files/1dbf22d3f45a929d22400b893024f1a4.png";